<template>
  <div
    v-if="daily"
    class="calendar-header daily"
  >
    <span>{{ weekDay }} {{ formattedDate }}</span>
  </div>
  <div
    v-else
    class="calendar-header"
  >
    <span>{{ trainerData.full_name }}</span>
  </div>
</template>

<script>
import { computed, ref, watchEffect } from 'vue';

import axios from 'axios';
import store from '@/store';

import { urlBuilder } from '@/plugins/helpers';

export default {
  name: 'CalendarHeader',

  props: {
    daily: Boolean,
    date: Object,
  },

  setup(props) {
    const formattedDate = computed(() => props.date.format('DD-MM-YYYY'));
    const weekDay = computed(() => props.date.locale('pl').format('dddd'));

    const trainerId = computed(() => store.getters.selectedTrainerId);

    const trainerData = ref({});

    async function getTrainer(id) {
      trainerData.value = (await axios.get(urlBuilder(`/trainers/${id}/`))).data;
    }

    if (!props.daily) getTrainer(trainerId.value);

    watchEffect(() => {
      if (trainerId.value) getTrainer(trainerId.value);
    });

    return {
      formattedDate,
      trainerData,
      weekDay,
    };
  },
};
</script>

<style scoped>
  .calendar-header {
    align-items: center;
    font-size: 24px;
    justify-content: center;
    text-align: center;
  }
  .daily {
    text-transform: capitalize;
  }
</style>
